/**
 * The motion tokens of src/assets/motion.css, for code that animates with WAAPI (`el.animate`) or sets inline
 * transitions (DetentSheet). Keep the two in sync: CSS is the source of truth for styles, this file for scripts.
 */

/** Durations in ms. */
export const DUR = {
    instant: 90,
    fast: 150,
    base: 240,
    push: 340,
    pop: 280,
    settle: 480,
} as const

/** Shorter durations under prefers-reduced-motion (same as the CSS media block). */
export const DUR_REDUCED: Record<keyof typeof DUR, number> = {
    instant: 1,
    fast: 120,
    base: 140,
    push: 160,
    pop: 140,
    settle: 160,
}

export const EASE = {
    out: 'cubic-bezier(0.22, 1, 0.36, 1)',
    ios: 'cubic-bezier(0.32, 0.72, 0, 1)',
    in: 'cubic-bezier(0.4, 0, 1, 1)',
    emph: 'cubic-bezier(0.05, 0.7, 0.1, 1)',
    springSoft: 'cubic-bezier(0.34, 1.3, 0.64, 1)',
    springPop: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
} as const

/** The iOS presentation curve's control points (velocity-matched snaps start from these). */
export const IOS_BEZIER = [0.32, 0.72, 0, 1] as const

/** Layer scale (z-index) for things teleported to <body>. */
export const Z = {
    chatStage: 30,
    chatDock: 35,
    overlay: 45,
    panel: 60,
    popup: 110,
    modal: 1000,
    sheetScrim: 10050,
    sheet: 10051,
    sheetModal: 10070,
    toast: 10080,
    call: 10090,
    previewer: 10600,
} as const

export function prefersReducedMotion(): boolean {
    if (typeof window === 'undefined' || !window.matchMedia) return false
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

/** A duration token, shortened when the creator prefers reduced motion. */
export function dur(name: keyof typeof DUR): number {
    return prefersReducedMotion() ? DUR_REDUCED[name] : DUR[name]
}
